module.exports = __webpack_public_path__ + "static/img/image-1.d943a297.png";